import React from "react";

const HowUseInformation = () => {
  return (
    <div className="flex flex-col items-start  sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        B.
        <span className="text-[#01A7D1] ">
          {" "}
          HOW WE USE THE INFORMATION WE COLLECT
        </span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          1. HOW PERSONAL INFORMATION IS USED
        </h1>
        We collect your personal information and aggregate information about the
        use of our Platform and Services to better understand your needs and to
        provide you with a better Platform experience. Specifically, we may use
        your personal information for any of the following reasons:
      </p>
      <ul className="text-md  text-[#444444] tracking-wide pt-3  list-disc px-10 ">
        <li className="py-2">
          To provide our Services to you, including registering you for our
          Services, verifying your identity and authority to use our Services,
          and to otherwise enable you to use our Platform and our Services;
        </li>
        <li className="py-2">
          For customer support and to respond to your inquiries;
        </li>
        <li className="py-2">For internal record-keeping purposes;</li>
        <li className="py-2">
          To process billing and payment, including sharing with third party
          payment gateways in connection with Platform and/or Services;
        </li>
        <li className="py-2">
          To improve and maintain our Platform and our Services (for example, we
          track information entered through the "Search" function; this helps us
          determine which areas of our Platform users like best and areas that
          we may want to enhance; we also will use for trouble-shooting
          purposes, where applicable);
        </li>
        <li className="py-2">
          To periodically send promotional emails to the email address you
          provide regarding new products offered by Yostel, special offers from
          Yostel or other information about Yostel that we think you may find
          interesting;
        </li>
        <li className="py-2">
          To contact you via email, telephone, facsimile or mail, or, where
          requested, by text message, to deliver certain services or information
          you have requested;
        </li>
        <li className="py-2">
          For Yostel's market research purposes, including, but not limited to,
          the customization of the Platform according to your interests;
        </li>
        <li className="py-2">
          We may use your demographic information (i.e., age, postal code,
          residential and commercial addresses, and other various data) to more
          effectively facilitate the promotion of goods and services to
          appropriate target audiences and for other research and analytical
          purposes;
        </li>
        <li className="py-2">
          To resolve disputes, to protect ourselves and other users of our
          Platform and Services, and to enforce our Platform’s terms and
          conditions;
        </li>
        <li className="py-2">
          We also may compare personal information collected through the
          Platform and Services to verify its accuracy with personal information
          collected from third parties; and
        </li>
        <li className="py-2">
          We may combine aggregate data with the personal information we collect
          about you.
        </li>
        <li className="py-2">
          We may disclose your personal information or part thereof to third
          party. Such information shall include name, email, mobile number, and
          other information which is capable of identifying you except for any
          ‘sensitive personal information’ as defined under Information
          Technology Act, 2000 and Information Technology (Reasonable security
          practices and procedures and sensitive personal data or information)
          Rules, 2011. This personal information is shared only to be used for
          lawful purposes including but not limited to making promotional calls
          and sending transactional messages and/or email notifications. Yostel
          does not endorse using personal information by third party for any
          illegal purposes.
        </li>
        <p className="text-md  text-[#444444] tracking-wide pt-3 ">
          From time to time, Yostel may use personal information for new and
          unanticipated uses not previously disclosed in our Privacy Policy. If
          our information practices change regarding information previously
          collected, Yostel shall make reasonable efforts to provide notice and
          obtain consent of any such uses as may be required by law.
        </p>
        <p className="text-md  text-[#444444] tracking-wide pt-3 ">
          It is further clarified that your registration on the Website shall be
          deemed to be your consent to be contacted for the purposes mentioned
          above, (i) on the mobile number shared by you even if you are
          registered with the National Customer Preference Register (NCPR) and
          have opted out of receiving promotional calls and messages and (ii) by
          way of SMS or email notifications or messages in any other electronic
          form.
        </p>
        <p className="text-md  text-[#444444] tracking-wide pt-3 ">
          It is further clarified that your registration on the Platform shall
          be deemed to be your consent to be contacted for the purposes
          mentioned above, (i) on the mobile number shared by you even if you
          are registered with the National Customer Preference Register (NCPR)
          and have opted out of receiving promotional calls and messages and
          (ii) by way of SMS or email notifications or messages in any other
          electronic form.
        </p>
      </ul>
    </div>
  );
};

export default HowUseInformation;
